export default function MODAL_WIDTH(width, isCentered = false) {
  const widths = {
    xs: 'w-[480px]',
    small: 'w-[640px]',
    medium: 'w-[800px]',
    large: 'w-[1056px]',
    full: 'w-full xxl:max-w-[1920px]'
  };
  // Cap to the viewport on small screens so a centered modal never overflows a phone
  // (min/max via min() keeps the desktop 480–576px range, no breakpoint needed).
  return isCentered
    ? 'min-w-[min(480px,calc(100vw_-_2rem))] max-w-[min(576px,calc(100vw_-_2rem))] max-h-[min(640px,var(--app-height,100vh))]'
    : widths[width];
}
